import { observer } from 'mobx-react-lite';
import { useStore } from '@shared/hooks/useStore';
import IconImages from '@shared/assets/images/icons';
import defaultCover from '@shared/assets/images/default-cover.png';
import { formatPublicationTitle } from '@shared/utils/publication';
import { PUBLICATION_TYPE } from '@shared/types/enums';

interface ReaderSidebarProps {
    onBuyNow?: () => void
}

const ReaderSidebar = observer(({ onBuyNow }: ReaderSidebarProps) => {
    const { readerStore, authStore } = useStore();
    const activeBook = readerStore.getActiveBook();

    if (!activeBook) {
        return (
            <div className='w-[320px] p-4 flex items-center justify-center border-r border-white-10 last:border-r-0'>
                <p className='text-white text-sm'>本を選択してください</p>
            </div>
        );
    }

    const { publication } = activeBook;

    return (
        <div className='min-h-full flex flex-col gap-4 w-full p-4 border-r border-[#FFFFFF1A] text-white'>
            <div className='flex gap-[13px]'>
                <div className='flex-shrink-0'>
                    <img
                        src={publication.linkImg}
                        alt={publication.title}
                        className='w-[128px] h-[172px] object-cover'
                        onError={(e) => {
                            e.currentTarget.src = defaultCover;
                        }}
                    />
                </div>

                <div>
                    <h2 className='font-semibold text-sm mb-1'>
                        {formatPublicationTitle(publication)}
                    </h2>
                    {publication.type === PUBLICATION_TYPE.Book && (
                        <p className='text-[11px] leading-[22px] line-clamp-1'>
                            著者：
                            {publication.author || '不明'}
                        </p>
                    )}
                </div>
            </div>

            {authStore.isStdIndividual && !(publication.owned || publication.isPurchase) && (
                <>
                    <div className='h-[1px] w-full bg-[#FFFFFF1A]' />

                    <button
                        onClick={onBuyNow}
                        className='w-full flex items-center justify-center gap-2 px-8 py-4 bg-primary text-white font-semibold rounded-[10px] transition-colors leading-[16px]'
                    >
                        <img src={IconImages.booksIc} alt='books' className='size-6' />
                        今すぐ買う
                    </button>
                </>
            )}

            <div className='text-xs leading-[26px] whitespace-pre-line'>
                {publication.description}
            </div>
        </div>
    );
});

export default ReaderSidebar;
